import React from 'react'
import { useHistory } from 'react-router-dom'

const QuotePage = props => {
  return (
    <div style={{ marginBottom: '25px' }}>
      <div className="container">
        <div className="row">
          <h2 className="page-title">Get a Quote</h2>
        </div>
      </div>
      <div className="title-block-bar" style={{ backgroundColor: '#57ad65' }}>
        <div className="container"></div>
      </div>
      <div style={{ backgroundColor: '#57ad65' }}>
        <div className="container"></div>
      </div>
      <div className="container" style={{ fontSize: '1.2rem', marginTop: '30px' }}>
        At this time, quoting has been disabled while we work through the logistics of our
        acquisition by PowerSchool. If you are interested in advanced capabilities for
        your career information system then we encourage you to
        <a href="https://www.powerschool.com/solutions/unified-communities/naviance/">
          take a look at Naviance's suite of products
        </a>
        .
      </div>
    </div>
  )
}

export default QuotePage
